import '../../CommonStyles.scss';
import { Loader } from '@trackman/web-shared-components';
import KpiCard from '../../components/KpiCard/KpiCard';
import { KpiDelta, KpiMeta } from '../../components/KpiMeta/KpiMeta';
import { useGetCertificationUserCounts, useGetActiveSubscriptionsKpi, useGetMasterCertifiedCount } from 'queryHooks/Admin/analytics';

export const OverviewTab = () => {
  const { data: certUserCounts, isLoading: certCountsLoading } = useGetCertificationUserCounts();
  const { data: activeSubsKpi, isLoading: activeSubsLoading } = useGetActiveSubscriptionsKpi();
  const { data: masterCertifiedCount, isLoading: masterCertifiedCountLoading } = useGetMasterCertifiedCount();

  return (
    <div className='analytics-tab'>
      {certCountsLoading || activeSubsLoading || masterCertifiedCountLoading ? (
        <div className='no-data'>
          <Loader size='large' />
        </div>
      ) : (
        <>
          <div className='overview-section'>
            <div className='section-grid metrics'>
              <ActiveSubscriptionsCard activeSubsKpi={activeSubsKpi} />
              <AutoRenewOnCard activeSubsKpi={activeSubsKpi} />
              <MasterCertifiedCard masterCertifiedCount={masterCertifiedCount} />
            </div>
          </div>

          <div className='overview-section'>
            <div className='section-grid metrics'>
              {certUserCounts
                ?.sort((a, b) => b.userCount - a.userCount)
                .map((c) => (
                  <CertificationCard id={c.certificationId} title={c.title} userCount={c.userCount} percentChange={c.percentChange} />
                ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const ActiveSubscriptionsCard = ({ activeSubsKpi }) => {
  return (
    <KpiCard label='Active Subscriptions' sources={['RECURLY']} value={activeSubsKpi?.activeSubscriptions ?? '—'}>
      {activeSubsKpi?.changePercent != null && <KpiDelta value={activeSubsKpi.changePercent} suffix='vs prev month' />}
    </KpiCard>
  );
};

const AutoRenewOnCard = ({ activeSubsKpi }) => {
  return (
    <KpiCard label='Auto-Renew ON' sources={['RECURLY']} value={activeSubsKpi?.renewingSubscriptions ?? '—'}>
      {activeSubsKpi?.renewingSubscriptionsPercent != null && (
        <KpiMeta tone='positive'>{activeSubsKpi.renewingSubscriptionsPercent.toFixed(1)}% of active</KpiMeta>
      )}
    </KpiCard>
  );
};

const MasterCertifiedCard = ({ masterCertifiedCount }) => {
  return <KpiCard label='Master Certified' sources={['DB']} value={masterCertifiedCount ?? '—'}></KpiCard>;
};

const CertificationCard = ({ id, title, userCount, percentChange }) => {
  return (
    <KpiCard key={id} label={title} sources={['DB']} value={userCount}>
      {<KpiDelta value={percentChange} suffix='vs prev month' />}
    </KpiCard>
  );
};

export default OverviewTab;
